// EventEmitter.js
const EventEmitter = {
    events: {},
    dispatch(event, data) {
      if (!this.events[event]) return;
      for (const callback of this.events[event]) {
        callback(data);
      }
    },
    subscribe(event, callback) {
      if (!this.events[event]) this.events[event] = [];
      this.events[event].push(callback);
    },
    unsubscribe(event, callback) {
      if (!this.events[event]) return;
      this.events[event] = this.events[event].filter((cb) => cb !== callback);
    },
  };
  
  export default EventEmitter;
  